import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchReceivedAdsLmtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchReceivedAdsLmtd = (filters: FetchReceivedAdsLmtdProps) => void;

const fetchReceivedAdsLmtd = ({
  startDate,
  endDate,
  report
}: FetchReceivedAdsLmtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchReceivedAdsLmtd;
